import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "ExaminerAssessment",
  [
    [
      "path",
      {
        d: "M20.37,6.15L15.06.84c-.43-.43-1.03-.68-1.64-.68h-7.15c-1.68,0-3.05,1.37-3.05,3.05v17.59c0,1.68,1.37,3.05,3.05,3.05h11.73c1.68,0,3.05-1.37,3.05-3.05V7.79c0-.61-.25-1.21-.68-1.64ZM19.26,7.49h-4.93c-.34,0-.61-.27-.61-.61V1.95s.09.06.13.1l5.31,5.31s.07.08.1.13ZM4.92,3.22c0-.74.6-1.34,1.34-1.34h5.74v5.01c0,1.28,1.04,2.32,2.32,2.32h5.01v11.61c0,.74-.6,1.34-1.34,1.34H6.27c-.74,0-1.34-.6-1.34-1.34V3.22Z",
      },
    ],
    [
      "path",
      {
        d: "M11.4,19.46c.91,0,1.78-.27,2.54-.78l1.99,1.99c.17.17.39.25.6.25s.44-.08.61-.25c.33-.33.33-.88,0-1.21l-1.99-1.99c.51-.75.77-1.63.77-2.53,0-2.49-2.03-4.52-4.52-4.52s-4.52,2.03-4.52,4.52,2.03,4.52,4.52,4.52ZM8.59,14.94c0-1.55,1.26-2.81,2.81-2.81s2.81,1.26,2.81,2.81-1.26,2.81-2.81,2.81-2.81-1.26-2.81-2.81Z",
      },
    ],
  ],
  "currentColor"
);
